import {useHistory} from 'react-router-dom';
import {createOrgPath} from '@core/lib/organizations';
import Designer from '@analytics/components/designer/index';
import {ManagePodlinkDomainRouteProps} from '.';

export function PodlinkDomainDesigner({
  organization,
  podlinkDomain,
}: ManagePodlinkDomainRouteProps) {
  const history = useHistory();

  const onComplete = () => {
    history.push(createOrgPath(organization, 'manage/podlink'));
  };

  return (
    <Designer
      organization={organization}
      podlinkDomain={podlinkDomain}
      onCancel={onComplete}
      onSave={onComplete}
    />
  );
}
